import React from 'react'
import styled from 'styled-components'

type Props = {
  cols?: number[]
  noMarginBottom?: boolean
}
export const FormGrid: React.FC<Props> = ({
  cols,
  noMarginBottom,
  children,
}) => {
  return (
    <StyledGrid cols={cols} noMarginBottom={noMarginBottom}>
      {children}
    </StyledGrid>
  )
}

interface GridProps {
  cols?: number[]
  noMarginBottom?: boolean
}

const StyledGrid = styled.div<GridProps>`
  display: grid;
  gap: 2rem;
  margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? '0' : '2rem')};

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    grid-template-columns: ${({ cols }) => (cols || [1]).join('fr ') + 'fr'};
  }
`
